export default __webpack_public_path__ + "static/media/DSC_0029.15286a78.jpg";